import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SetSupportRequestStatusMutation } from "../graphql/mutations";
import type {
  SetSupportRequestStatusMutationType,
  SetSupportRequestStatusMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useSetSupportRequestStatusMutation = (
  options?: MutationHookOptions<
    SetSupportRequestStatusMutationType,
    SetSupportRequestStatusMutationVariablesType
  >
) =>
  useMutation<
    SetSupportRequestStatusMutationType,
    SetSupportRequestStatusMutationVariablesType
  >(SetSupportRequestStatusMutation, options);
